import { formatCurrencyAmount } from "@/components/pages/services/utils/priceFormatting";

/** Formats a numeric EUR amount for partner tables and detail (no locale grouping). */
export function formatGuesteriaPartnerRevenueEur(value: number): string {
  return formatPartnerRevenueValue(value, "EUR");
}

export function formatPartnerRevenueValue(
  value: number,
  currency: string,
): string {
  return formatCurrencyAmount(value, currency);
}

/** Placeholder shown under a partner service name when it has no location. */
export const PARTNER_SERVICE_LOCATION_EMPTY = "—";

/** "City, Country" for the Name column; missing parts are skipped, nothing set gives "—". */
export function formatPartnerServiceLocation(
  destination:
    | {
        destinationName?: string | null | undefined;
        regionName?: string | null | undefined;
        countryName?: string | null | undefined;
      }
    | null
    | undefined,
): string {
  const city = destination?.destinationName?.trim() ?? "";
  const country = destination?.countryName?.trim() ?? "";
  const parts = [city, country].filter(
    (part, index, all) => part !== "" && all.indexOf(part) === index,
  );
  return parts.length > 0 ? parts.join(", ") : PARTNER_SERVICE_LOCATION_EMPTY;
}
